import React from "react";
import { NewTitleHeader } from "./TitleHeader";
import { AreaRadarChart } from "../graph/AverageGraph";
import "./AreaAnalysis.scss";

interface AreaAnalysisProps {
  avgArea1: any[];
  avgArea2: any[];
  contentScoreMap: Record<string, number>;
  behaviorScoreMap: Record<string, number>;
}

const AreaAnalysis = ({ avgArea1, avgArea2, contentScoreMap, behaviorScoreMap }: AreaAnalysisProps) => {
  const contentRadarData = avgArea1.map((item: any) => ({
    area: item.area,
    student: contentScoreMap[item.area] ?? 0,
    average: parseFloat(item.average),
    total: parseFloat(item.total_points),
  }));
  const behaviorRadarData = avgArea2.map((item: any) => ({
    area: item.area,
    student: behaviorScoreMap[item.area] ?? 0,
    average: parseFloat(item.average),
    total: parseFloat(item.total_points),
  }));

  return (
    <div>
      <div className="area-analysis" style={{ display: 'flex' }}>
        <div className="left-div">
          <NewTitleHeader title="내용 영역 성취도 분석" comment="" />
          <table className="content-area-table">
            <thead>
              <tr>
                <th>평가영역</th>
                <th>내 점수</th>
                <th>동일 학년 평균</th>
                <th>총점</th>
              </tr>
            </thead>
            <tbody>
            {avgArea1.map((item: any) => (
                <tr key={item.area}>
                  <td>{item.area}</td>
                  <td>{Math.round((contentScoreMap[item.area] ?? 0) * 10) / 10}</td>
                  <td>{+parseFloat(item.average).toFixed(1)}</td>
                  <td>{+parseFloat(item.total_points).toFixed(1)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="right-div">
          <div className="behavior-area-container">
            <AreaRadarChart data={contentRadarData} />
          </div>
        </div>
      </div>
      <div className="area-analysis" style={{ display: 'flex' }}>
        <div className="left-div">
          <NewTitleHeader title="행동 영역 성취도 분석" comment="" />
          <table className="content-area-table">
            <thead>
              <tr>
                <th>행동영역</th>
                <th>내 점수</th>
                <th>동일 학년 평균</th>
                <th>총점</th>
              </tr>
            </thead>
            <tbody>
              {avgArea2.map((item: any) => (
                <tr key={item.area}>
                  <td>{item.area}</td>
                  <td>{Math.round((behaviorScoreMap[item.area] ?? 0) * 10) / 10}</td>
                  <td>{+parseFloat(item.average).toFixed(1)}</td>
                  <td>{+parseFloat(item.total_points).toFixed(1)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="right-div">
          <div className="behavior-area-container">
            <AreaRadarChart data={behaviorRadarData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AreaAnalysis;
